// TODO Add a couple lines about each project
const data = [
  {
    title: 'Diffusion-Based Image Restoration: A Zero-Shot Approach',
    subtitle: '',
    image: '/images/projects/DDNM.png',
    link: 'https://github.com/186shades/ECE285-Final-Project',
    date: '2024-06-1',
    desc: 'A zero-shot image inpainting technique based on the Denoising Diffusion Null-Space Model (DDNM+) for image reconstruction on occluded surgical images',
  },
  {
    title: 'Dust-Fragment classification @ UCSD ARCLab',
    subtitle: '',
    image: '/images/projects/SRIP.jpg',
    link: 'https://ucsdarclab.com/',
    date: '2024-06-1',
    desc: 'Integrating segmentation models with optical flow for enhanced moving object detection and classification in ureteroscopy videos',
  },
  {
    title: 'CT Imaging: Monte Carlo Simulation for Dose Estimation',
    subtitle: '',
    image: '/images/projects/ct_dose.png',
    link: 'https://github.com/186shades/ct-dose-estimation',
    date: '2024-12-1',
    desc: 'Estimating radiation dose in fetal CT imaging using Monte Carlo simulations, with a focus on how dose distribution varies across tissue categories',
  },
  {
    title: 'Inpainting Detection Using Wavelet-Based Features',
    subtitle: '',
    image: '/images/projects/wavelets.png',
    link: 'https://github.com/GSNikhil/inpainting-detection',
    date: '2024-12-1',
    desc: 'Replicate DTCWT implementation (Barglazan and Brad) and extend it for multiple wavelet families assessing their efficacy for inpainting detection',
  },
  {
    title: 'Multimodal State Classification for Industrial Device',
    subtitle: '',
    image: '/images/projects/multimodal.png',
    link: 'https://github.com/186shades/ECE228-Final-Project',
    date: '2024-06-1',
    desc: 'Multimodal deep learning model leveraging image and time-series data from milling blade to accurately classify it\'s state',
  },
  {
    title: 'GPU Acceleration of FFT Algorithm',
    subtitle: '',
    image: '/images/projects/fft.png',
    link: 'https://github.com/186shades/gpu-optimized-fft',
    date: '2024-12-1',
    desc: 'Optimizing the Cooley-Tukey FFT algorithm for GPU acceleration using CUDA for improved performance in signal processing applications',
  },
  {
    title: 'Histopathology image classification for cancer diagnosis',
    subtitle: '',
    image: '/images/projects/Histopathology.png',
    link: 'https://github.com/186shades/ECE271BProject',
    date: '2024-03-1',
    desc: 'Comparative analysis between CNNs & Vision Transformers Fine-tuned using transfer learning & data augmentation for skin cancer detection',
  },
  {
    title: 'MRI: bSSFP Simulation with Stack-of-Stars Sampling',
    subtitle: '',
    image: '/images/projects/mri.png',
    link: 'https://github.com/186shades/mri-bSSFP-simulation',
    date: '2024-12-1',
    desc: 'Simulation of balanced steady-state free precession (bSSFP) MRI sequence with stack-of-stars sampling for improved image quality',
  },
  {
    title: 'Data Analysis for Solar Radiation and Grid Simulation',
    subtitle: '',
    image: '/images/projects/California.gif',
    link: 'https://github.com/186shades/ECE143-Team13',
    date: '2024-03-1',
    desc: 'Analysis of solar supply and energy demand data in USA with focus on grid simulations to assess supply-demand gap in California',
  },
  {
    title: 'Student Engagement Analytics Platform for Campus Health Services',
    subtitle: '',
    image: '/images/projects/SHS.png',
    link: 'https://github.com/186shades/ucsd-shs-viz-tool',
    date: '2024-03-1',
    desc: 'A web-based tracking and visualization application for Student Health Services at UCSD for better assessment of student engagement',
  },
];

export default data;
